initListeners=function(){
  $(window).scroll(function(event) {
    valorScroll=$(window).scrollTop();

    // añade clase "enpantalla" cuando aparece en pantalla
    $(".js-aparece-scroll").each(function(index, el) {
      if ($(this).offset().top+$(this).height()<=valorScroll+$(window).height()){
        $(this).addClass("enpantalla");
      }else{
        $(this).removeClass("enpantalla");
      }
    });
  });

  /**
   * LISTENER validador formularios
   */
  $('.js-form-validator').validator(customValidations()).on('submit', function (e) {
    if ($(this).data('enviar-ajax') == undefined || $(this).data('enviar-ajax') == true){
          enviar_por_ajax = true;
    }else{
          enviar_por_ajax = false;
    }

    if (e.isDefaultPrevented() ) {
      $(this).find('.has-error').each(function(index, element){
        // console.log("hay errores");
      });
    }
    else{
      //console.log('pasa');
        if ($(this).data('spinner-holder') != ''){
          spinner_holder = $($(this).data('spinner-holder')).find('.js-spinner-holder');
        }else{
          $('body').find('.js-spinner-holder');
        }
        spinner_holder.fadeIn();

        // Si hay que enviarlo por ajax ejecutamos simpleAjaxForm, si no, dejamos que haga el submit
        $(this).find("button[type='submit']").addClass('btn-loader');
        if (enviar_por_ajax){
          //console.log('enviar ajax');
          if ($(this).data('archivos')){
            //console.log('ini');
              $(this).simpleAjaxFormFiles();
          }
          else{
              $(this).simpleAjaxForm();
          }    
              e.preventDefault();
        }

    } 
  });

  /**
   * LISTENER para mostrar/ocultar objetos
   */
  $(".js-toggle-div").click(function(){
    var obj=$(this).data("toggle-div");
    $(obj).toggleClass("desactivo");
  })

  /**
   * LISTENER menus con ancla
   */
  $(".js-menu-ancla").click(function(e){
    e.preventDefault();
    var ancla=$(this).attr("href");
    var offset=$(this).data("menuancla-offset");
    if(offset=="" || offset==undefined){
      offset=0;
    }
    PLG_scrollTo(1,ancla,0,offset,0);
  })

  /**
   * LISTENER para despliegue menú hamburguesa
   */
  $('#menu_desplegable').on('show.bs.collapse', function () {
    PLG_showMenu();
    PLG_closeModalLogin();
  });
  $("#menu_desplegable .close").click(function(){
    PLG_closeMenu();
  });

  /**
   * LISTENER para mostrar modal login
   */
  $(".js-btn-header-login").click(function(){
    if($("#menu_desplegable").hasClass("show")){
      PLG_closeMenu(function(){
         PLG_toggleModalLogin();
      });
    }else{
      PLG_toggleModalLogin();
    }
  });

  /**
   * LISTENER para mostrar modal alerta
   */
  $(".js-modal-alerta").click(function(){
    PLG_showModalAlerta($(this).data("alerta-titulo"),$(this).data("alerta-texto"));
  });

  /**
   * LISTENER cierre cookies
   */
  // $("#modal-cookies .close").click(function(){
  //   $("#modal-cookies").fadeOut();
  //   setCookie("aceptacion-cookies", "true", 365);
  // });
  // checkCookie("aceptacion-cookies");

  /**
   * LISTENER copiar de un input
   */
  $(".js-btn-copy").click(function() {
      var target=$(this).data("target-copy");
      copyToClipboard(document.getElementById(target));
  });


/**
 * funcion parallax de movimiento raton
 * [necesita clase js-parallaxElement]
 * [atributo data-movimientopxy] -> para indicar velocidad Y
 * [atributo data-movimientopxx] -> para indicar velocidad X
 */
  $( document ).mousemove( function( e ) {
    //variables globales
    ancho=$(window).width()/2;
    alto=$(window).height()/2;
    posx=e.clientX-ancho;
    posy=e.clientY-alto;
    pctx=parseInt(posx*100/ancho,10);
    pcty=parseInt(posy*100/alto,10);

    $('.js-parallaxMouse').each(function(index, el){
      tempx=pctx*parseInt($(el).attr("data-movimientopxx"),12)/100*-1;
      tempy=pcty*parseInt($(el).attr("data-movimientopxy"),12)/100*-1;
      $(el).css({
        '-ms-transform': 'translate('+tempx+'px, '+tempy+'px)',
        '-webkit-transform': 'translate('+tempx+'px, '+tempy+'px)',
        'transform': 'translate('+tempx+'px, '+tempy+'px)'
      });
    });
    $(".js-alphaElement").each(function(index, el) {
      if ($(window).scrollTop() < parseInt($(this).attr("data-topescroll"),10)){
        pct=e.clientX*100/$(window).width();
        $(el).find("img").css({
          'opacity': pct/100,
        });
      }
    });
  });


/**
 * funcion parallax de movimiento scroll
 * [necesita clase js-parallaxScroll]
 * [atributo data-movimientopxy] -> para indicar velocidad Y
 */
  $( window ).scroll( function( e ) {
    //variables globales
    alto=$(window).height()/2;
    posy=$(window).scrollTop();
    pcty=parseInt(posy*100/alto,10);

    $('.js-parallaxScroll').each(function(index, el){
      tempy=pcty*parseInt($(el).attr("data-movimientopxy"),12)/100*-1;
      $(el).css({
        '-ms-transform': 'translateY('+tempy+'px)',
        '-webkit-transform': 'translateY('+tempy+'px)',
        'transform': 'translateY('+tempy+'px)'
      });
    });
  });

};


  /**
   * cookies
   */
  checkCookie('cookies-tecnica');

  $('.js-configurar').on('click', function () {
    $('.js-formulario-cookies').show();
  });

  $("#modal-cookies .close").click(function () {
    $("#modal-cookies").fadeOut();
    setCookie("cookies-tecnica", "true", 365);
    $("#tapa-cookies").fadeOut();
  });

  $(".js-aceptar-cookies").click(function () {
    $("#modal-cookies").fadeOut();
    $("#tapa-cookies").fadeOut();
    setCookie("cookies-tecnica", "true", 365);

    if ($("#cookie_estadisticas").is(':checked')) {
      setCookie("cookies-estadisticas", "true", 365);

      (function (i, s, o, g, r, a, m) {
        i['GoogleAnalyticsObject'] = r; i[r] = i[r] || function () {
          (i[r].q = i[r].q || []).push(arguments)
        }, i[r].l = 1 * new Date(); a = s.createElement(o),
          m = s.getElementsByTagName(o)[0]; a.async = 1; a.src = g; m.parentNode.insertBefore(a, m)
      })(window, document, 'script', '//www.google-analytics.com/analytics.js', 'ga');
      ga('create', 'UA-xxxx', 'auto');
      ga('send', 'pageview');

      $('.js-noactivarGA').addClass('js-activarGA');
      $('.js-noactivarGA').removeClass('js-noactivarGA');
      initGA();
    }


  });

  function initGA() {
      $('.js-activarGA').on('click', function () {
        var pag = $(this).attr('data-pagina');
        var evento = $(this).attr('data-evento');
        ga('send', 'event', pag, 'CLICK', evento);
      });
  }